import formComponent from '@/util/proto/formComponent'
import { phoneValidator, emptyValidator } from '@/util/validator'

export default {
  extends: formComponent,
  data() {
    return {
      formData: {
        repairSiteName: {
          rules: [
            { required: true, message: '站点名称不能为空', trigger: 'blur,change' },
          ]
        },

        contact: {
          rules: [
            { required: true, message: '联系人不能为空', trigger: 'blur,change' },
          ]
        },
        contactPhone: {
          rules: [
            { required: true, message: '联系电话不能为空', trigger: 'blur,change' },
            { validator: phoneValidator('请输入手机号', '请输入正确格式的手机号'), trigger: 'blur,change' },
          ]
        },
        address: {
          rules: [
            { required: true, message: '所在地址不能为空', trigger: 'blur,change' },
          ]
        },
        districtCode:{
          rules: [
            { required: true, message: '地区不能为空', trigger: 'blur,change' },
          ]
        },
        location: {
          rules: [
            { required: true, validator: emptyValidator('请指定位置', 'array'), trigger: 'blur,change' }

          ]
        },
        bankCard:null,
        remark: null
      },
      state:{
        districtName:null
      },
      def: {},
      id: null,
      loading: false,
      visible: false,
      api:['assBranchCreate','assBranchUpdate'],
    }
  },

  computed: {
    itemTitle() {
      return this.id ? '编辑维修点' : '新增维修点'
    },
  },
  created() {
    this.def = { ...this.form }
  },

  methods: {

    init(id) {
      this.id = id
      this.visible = true
      this.reset()

      if (this.id) {
        this.query()
      }
    },

    query() {
      this.loading = true
      this.$request.assBranch(this.id).then(resp => {
        this.loading = false

        if (resp.data.latitude && resp.data.longitude) {
          resp.data.location = [resp.data.longitude , resp.data.latitude]
        }else{
          resp.data.location = []
        }
        this.state.districtName = resp.data.districtName

        //TODO 此处需要强制更新
        this.$setFormData(resp.data , false , true)
      })
    },
    reset() {
      this.$resetFormData()
    },
    save(d) {
      let {location , ...params} = d
      if(this.id){
        params.id = this.id
      }
      if(location.length == 2){
        params.longitude = location[0]
        params.latitude = location[1]
      }
      params.districtName = this.state.districtName

      this.loading = true

      this.$request(this.id ? 'assBranchUpdate' : 'assBranchCreate')(params).then(resp => {

        if (resp.code > 0) {
          this.$Message.error(resp.msg)
        } else if (resp.code == 0) {
          this.$Message.success('保存成功')
          this.$emit('update')

          this.visible = false
        }
        this.loading = false
      })
    },
    handleChangeArea(data){
      this.state.districtName = data.map(i => i.name).join('')
    }
  },
  render() {
    const { itemTitle, formData, loading, extraEditable } = this

    return (
      <sl-side-panel v-model={this.visible} loading={loading} mask-closable={false} title={itemTitle}>
          <sl-form label-width={100}>
            <sl-form-item label="站点名称">
              <Input v-decorator={formData.repairSiteName}></Input>
            </sl-form-item>
            <sl-form-item label="联系人">
              <Input v-decorator={formData.contact}></Input>
            </sl-form-item>
            <sl-form-item label="联系电话">
              <Input v-decorator={formData.contactPhone}></Input>
            </sl-form-item>
            <sl-form-item label="所属区域" prop="districtCode">
              <sl-area v-decorator={formData.districtCode} on-change-data={this.handleChangeArea} data-type="code" level={2} />
            </sl-form-item>
            <sl-form-item label="所在地址">
              <Input v-decorator={formData.address}></Input>
            </sl-form-item>
            <sl-form-item label="地理位置">
              <sl-amap style="height:260px;">
                <sl-amap-location v-decorator={formData.location} cs="wgs84"></sl-amap-location>
                <sl-amap-fullscreen />
              </sl-amap>
            </sl-form-item>
            <sl-form-item label="银行卡号">
              <Input v-decorator={formData.bankCard}></Input>
            </sl-form-item>
            <sl-form-item label="备注">
              <Input type="textarea" autosize={{minRows: 5,maxRows: 8}} v-decorator={formData.remark}></Input>
            </sl-form-item>
          </sl-form>
          <div slot="footer">
            <Button loading={loading} on-click={this.$handleSubmit} type="primary">确定</Button>
          </div>
      </sl-side-panel>
    )
  }
}

export const View = {
  data() {
    return {
      id: null,
      loading: false,
      data: {},
      visible: false,
    }
  },
  methods: {

    init(id) {
      this.id = id
      this.visible = true
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.loading = true
      this.$request.assBranch(this.id).then( resp => {
        this.loading = false
        if(resp.code == 0){
          resp.data.location = [ resp.data.longitude , resp.data.latitude]
          this.data = this.$utils.conv(resp.data,{'gender':'$gender' , 'entryTime':'datetime'})
        }else{
          this.visible = false
          this.$Message.error({ content: resp.msg })
        }
      })
    },
  },
  render(){
    const { loading , data } = this
    return (
      <sl-side-panel destroyOnClose={true} v-model={this.visible} mask-closable={false} title="查看维修点" loading={loading}>
        <sl-detail-list col={1} label-width="100px" label-align="right" style="padding:12px;">
          <sl-detail-list-item title="站点名称">{data.repairSiteName}</sl-detail-list-item>
          <sl-detail-list-item title="联系人">{data.contact}</sl-detail-list-item>
          <sl-detail-list-item title="联系电话">{data.contactPhone}</sl-detail-list-item>
          <sl-detail-list-item title="所属区域">{data.districtName}</sl-detail-list-item>
          <sl-detail-list-item title="所在地址">{data.address}</sl-detail-list-item>
          <sl-detail-list-item title="地理位置">
            <sl-amap style="height:300px;">
              <sl-amap-marker center={data.location} cs="wgs84" />
            </sl-amap>
          </sl-detail-list-item>
          <sl-detail-list-item title="银行卡号">{data.bankCard}</sl-detail-list-item>
          <sl-detail-list-item title="备注">{data.remark}</sl-detail-list-item>
        </sl-detail-list>
      </sl-side-panel>
    )
  }
}